import { useEventListener } from "@reactuses/core";
import type { RefObject } from "react";

type KeyPressEvent = "keydown" | "keypress" | "keyup";

type KeyPressTarget =
    | Document
    | EventTarget
    | HTMLElement
    | Window
    | RefObject<EventTarget | null>
    | (() => EventTarget | null);

export interface UseKeyPressOptions {
    event?: KeyPressEvent;
    eventOptions?: AddEventListenerOptions | boolean;
    target?: KeyPressTarget;
}

export function useKeyPress(
    key: string,
    callback: (event: KeyboardEvent) => void,
    options: UseKeyPressOptions = {},
) {
    const { event = "keydown", eventOptions, target } = options;

    function handleKeyPress(keyboardEvent: KeyboardEvent) {
        if (keyboardEvent.key === key) {
            callback(keyboardEvent);
        }
    }

    useEventListener(event, handleKeyPress, target, eventOptions);
}
